import cookies from 'react-cookies';

export const getMarkets = () => ({
  endpoint: '/GLO/all/all/en/markets',
});

const channel = 'mra';
const device = 'mobile';

export const doLogin = ({
  userId, password, mrktCd, langCd,
}) => ({
  method: 'POST',
  endpoint: '/login',
  data: {
    userId,
    password,
    mrktCd,
    langCd,
    device: 'web',
  },
});

export const getSlProfile = (mrktCd, langCd) => ({
  endpoint: `/${mrktCd || cookies.load('mrktCd')}/${channel}/${device}/${langCd || cookies.load('langCd')}/salesLeader/profiles?endpointCd=getSalesLeaderProfiles`,
});

export const setProfileShared = (mrktCd, langCd) => ({
  method: 'POST',
  endpoint: `/${mrktCd || cookies.load('mrktCd')}/prp/mobile/${langCd || cookies.load('langCd')}/salesLeader/profile?endpointCd=editSharedPrp`,
  data: {
    profile: { shared: true },
  },
});

export const checkAgreements = (mrktCd, langCd) => ({
  endpoint: `/${mrktCd || cookies.load('mrktCd')}/${channel}/${device}/${langCd || cookies.load('langCd')}/salesLeaders/agreements/validate?endpointCd=validateWebTC`,
});

export const getTacContent = (type, mrktCd, langCd) => ({
  endpoint: `/${mrktCd || cookies.load('mrktCd')}/${channel}/${device}/${langCd || cookies.load('langCd')}/${type}`,
});

export const acceptLegalInfo = data => ({
  method: 'POST',
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/salesLeaders/agreements/accept?endpointCd=salesLeaderTC`,
  data,
});

export const getViewAllLeads = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/viewAllLeads`,
});

export const getLeadsByStatus = ({
  searchStr, sortName, pagination, filters,
}) => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/appts/query?endpointCd=leadData`,
  method: 'POST',
  data: {
    searchStr,
    sortName,
    pagination,
    filters,
  },
});

export const getDashboard = (userId, mrktCd, langCd) => ({
  endpoint: `/${mrktCd || cookies.load('mrktCd')}/${channel}/${device}/${langCd || cookies.load('langCd')}/dashboard?userId=${userId}`,
});

export const getLoginInfo = (mrktCd, langCd) => ({
  endpoint: `/${mrktCd || cookies.load('mrktCd')}/${channel}/${device}/${langCd || cookies.load('langCd')}/login`,
});

export const getNotificationSnsInfo = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/snsInfo`,
});

export const getNotificationSnsList = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/snsList`,
});

export const getNotificationsInfo = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notificationsInfo`,
});

export const getNotificationCount = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notification/receipt/count`,
});

export const getNotificationList = ({
  userId, status, pageIndex = 0, pageSize = 15,
}) => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notification/search`,
  method: 'POST',
  data: {
    userId,
    status,
    pageIndex,
    pageSize,
  },
});

export const getNotificationData = id => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notification/get?id=${id}`,
});

export const deleteNotification = id => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notification/delete?id=${id}`,
  method: 'DELETE',
});

export const batchDeleteNotification = ids => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notification/batchDelete`,
  method: 'DELETE',
  data: ids,
});

export const updateStatusForNotifications = ({
  idList, status,
}) => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notification/update`,
  method: 'POST',
  data: {
    idList,
    status,
  },
});

export const getNotificationSettings = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notification/receipt/get`,
});

export const editNotificationSetting = data => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/notification/receipt/edit`,
  method: 'POST',
  data,
});

export const getNotificationSnsReceipt = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/snsReceipt`,
});

export const setFirstLoginPage = () => ({
  endpoint: '/updateUser',
  method: 'PUT',
  data: {
    firstLoginPage: false,
  },
});

export const getHelpSupportInfo = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/helpSupportInfo`,
});

export const getTC = type => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/${type}`,
});

export const getOptOutConfig = () => ({
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/optOutPage`,
});

export const getOptOut = () => ({
  method: 'POST',
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/salesLeader/info?endpointCd=getSalesLeaderInfo`,
});

export const setOptOut = status => ({
  method: 'PUT',
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/salesLeaders?endpointCd=editSalesLeaderOptOut`,
  data: {
    optOut: {
      status,
    },
  },
});

export const getSSO = (authAppType, landingPage) => ({
  method: 'POST',
  endpoint: `/${cookies.load('mrktCd')}/${cookies.load('langCd')}/authSSO`,
  data: {
    authAppType,
    landingPage,
  },
});

export const checkFirstLoginPage = (userId, mrktCd) => ({
  endpoint: `/${mrktCd || cookies.load('mrktCd')}/checkFirstLoginPage?userId=${userId}`,
});

export const saveCloseAccount = reason => ({
  method: 'POST',
  endpoint: `/${cookies.load('mrktCd')}/${channel}/${device}/${cookies.load('langCd')}/salesLeaders?endpointCd=closeAccount`,
  data: {
    reason,
  },
});
